<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="m-portlet m-portlet--tab">
          <div class="m-portlet__body">
            <div>
              <span class="loading-request" v-show="loading"></span>
              <div
                class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-4 border-bottom"
              >
                <h1 class="h2">Perfis de Acesso</h1>
                <div class="btn-toolbar mb-2 mb-md-0">
                  <div class="btn-group btn-group-sm" role="group" aria-label="Menu dos Perfis">
                    <span
                      class="btn btn-outline-brand"
                      @click="openSaveRole('add')"
                      v-b-tooltip.hover
                      title="Novo Perfil!"
                    >
                      <i class="fas fa-plus-square"></i>&nbsp; Cadastrar
                    </span>
                  </div>
                </div>
              </div>
              <div class="page-amounts">
                <nav aria-label="...">
                  <ul class="pagination pagination-md">
                    <li class="page-item" :class="{ selected: amount == 3 }">
                      <a @click="amount = 3" class="page-link paginate">3</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount == 10 }">
                      <a @click="amount = 10" class="page-link paginate">10</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount == 50 }">
                      <a @click="amount = 50" class="page-link paginate">50</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount == 100 }">
                      <a @click="amount = 100" class="page-link paginate">100</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount == 150 }">
                      <a @click="amount = 150" class="page-link paginate">150</a>
                    </li>
                  </ul>
                </nav>
              </div>
              <div class="paginator-info-top m-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de
                  {{ data.total }}.</span
                >
                <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
              </div>
            </div>
            <div class="table-responsive">
              <div class="container-table">
                <table class="table table-striped- table-bordered table-hover table-checkable">
                  <thead>
                    <tr>
                      <td
                        nowrap
                        class="text-center align-middle pointer"
                        width="60"
                        :class="{ 'table-sorted': sortType == 'id' }"
                        @click="sortCall('id')"
                      >
                        ID Perfil
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType == 'id' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType == 'id' && sortReverse"
                        ></span>
                        <span class="fal fa-sort sort" v-if="sortType != 'id'"></span>
                      </td>
                      <td
                        nowrap
                        class="text-center align-middle pointer"
                        width="200"
                        :class="{ 'table-sorted': sortType == 'name' }"
                        @click="sortCall('name')"
                      >
                        Perfil
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType == 'name' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType == 'name' && sortReverse"
                        ></span>
                        <span class="fal fa-sort sort" v-if="sortType != 'name'"></span>
                      </td>
                      <td
                        nowrap
                        class="text-center align-middle pointer"
                        width="200"
                        :class="{ 'table-sorted': sortType == 'desc' }"
                        @click="sortCall('desc')"
                      >
                        Detalhe
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType == 'desc' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType == 'desc' && sortReverse"
                        ></span>
                        <span class="fal fa-sort sort" v-if="sortType != 'desc'"></span>
                      </td>
                      <td nowrap class="text-center align-middle" width="80">Ações</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @keypress="validateValueNumber"
                          @input="callData"
                          v-model="filters.id"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @input="callData"
                          v-model="filters.name"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @input="callData"
                          v-model="filters.desc"
                        />
                      </td>

                      <td class="text-center align-middle" nowrap>
                        <button
                          type="button"
                          class="btn btn-outline-brand btn-sm btn-outline-metal btn-sm mr-1"
                          @click="callData"
                          v-b-tooltip.hover
                          title="Clique para filtrar"
                        >
                          <i class="far fa-search"></i> Filtrar
                        </button>
                        <button
                          type="button"
                          class="btn btn-outline-brand btn-sm btn-outline-metal btn-sm"
                          @click="clearFilters"
                          v-b-tooltip.hover
                          title="Clique para limpar os filtros"
                        >
                          <i class="far fa-eraser"></i> Limpar
                        </button>
                      </td>
                    </tr>
                    <tr v-for="(role, id) in data.data" :key="id">
                      <td class="text-center align-middle">{{ role.id }}</td>
                      <td class="text-left align-middle">{{ role.name }}</td>
                      <td class="text-center align-middle">{{ role.desc }}</td>
                      <td nowrap class="text-center align-middle">
                        <a
                          href="#"
                          @click.prevent.stop="openSaveRole(role.id)"
                          class="icon-circle ml-1"
                          v-b-tooltip.hover
                          title="Editar Cadastro"
                        >
                          <i class="fas fa-edit"></i>
                        </a>
                        <a
                          href=""
                          @click.prevent.stop="confirmDel(role.id)"
                          class="icon-circle"
                          v-b-tooltip.hover
                          title="Excluir Perfil"
                        >
                          <i class="fas fa-trash"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div>
              <div class="paginator-info-bottom mt-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de
                  {{ data.total }}.</span
                >
                <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
              </div>
              <div class="paginator-list">
                <nav aria-label="...">
                  <ul class="pagination pagination-md">
                    <li class="page-item" :class="{ disabled: data.current_page == 1 }">
                      <a class="page-link paginate" @click="page = 1"
                        ><i class="fal fa-angle-double-left"></i
                      ></a>
                    </li>
                    <li class="page-item" :class="{ disabled: data.current_page == 1 }">
                      <a class="page-link paginate" @click="page = data.current_page - 1"
                        ><i class="fal fa-angle-left"></i
                      ></a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                      v-if="data.current_page > 2"
                    >
                      <a class="page-link paginate" @click="page = data.current_page - 2">
                        {{ data.current_page - 2 }}</a
                      >
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                      v-if="data.current_page > 1"
                    >
                      <a class="page-link paginate" @click="page = data.current_page - 1">
                        {{ data.current_page - 1 }}</a
                      >
                    </li>
                    <li class="page-item selected">
                      <a class="page-link paginate"> {{ data.current_page }} </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                      v-if="data.current_page < data.last_page"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 1">
                        {{ data.current_page + 1 }}
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page + 1 == data.last_page }"
                      v-if="data.current_page + 1 < data.last_page"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 2">
                        {{ data.current_page + 2 }}
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 1"
                        ><i class="fal fa-angle-right"></i
                      ></a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                    >
                      <a class="page-link paginate" @click="page = data.last_page"
                        ><i class="fal fa-angle-double-right"></i
                      ></a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div class="pt-4"></div>
          </div>
        </div>
      </div>
      <transition name="slideleft" mode="out-in">
        <RoleModal v-if="showRoleSave" @updateList="callData" />
      </transition>
      <transition name="fade" mode="out-in">
        <div class="m-quick-sidebar-overlay" v-if="showRoleSave" @click="closeSaveRole()"></div>
      </transition>
    </div>
  </div>
</template>

<script>
import RoleModal from '@/components/users/manager/roles/RoleModal';
import { returnMessageMixin } from '@/mixins/returnMessageMixin.js';
import { validationFilterValueMixin } from '@/mixins/validationFilterValueMixin.js';

import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageMixin, validationFilterValueMixin],
  name: 'Roles',
  components: { RoleModal },
  data() {
    return {
      data: {},
      sortType: localStorage.rolesSortType ? localStorage.rolesSortType : 'id',
      sortReverse: localStorage.rolesSortReverse
        ? JSON.parse(localStorage.rolesSortReverse)
        : false,
      amount: localStorage.rolesDataAmount ? localStorage.rolesDataAmount : 100,
      page: localStorage.rolesDataPage ? localStorage.rolesDataPage : 1,
      filters: {
        id: localStorage.rolesFilterId ? localStorage.rolesFilterId : '',
        name: localStorage.rolesFilterName ? localStorage.rolesFilterName : '',
        desc: localStorage.rolesFilterDesc ? localStorage.rolesFilterDesc : '',
      },
    };
  },
  computed: {
    loading() {
      return !this.data.current_page;
    },
    showRoleSave() {
      return this.$store.state.showRoleSave;
    },
  },
  methods: {
    setFilter(filterToChange, id) {
      this.filters[filterToChange] = id;
      this.callData();
    },
    clearFilters() {
      this.filters.id = '';
      this.filters.name = '';
      this.filters.desc = '';
      this.filters.sortType = 'name';
      this.filters.sortReverse = false;
      this.callData();
    },
    setStorageFilters() {
      localStorage.setItem('rolesFilterId', this.filters.id);
      localStorage.setItem('rolesFilterName', this.filters.name);
      localStorage.setItem('rolesFilterDesc', this.filters.desc);
      localStorage.setItem('rolesDataAmount', this.amount);
      localStorage.setItem('rolesDataPage', this.page);
      localStorage.setItem('rolesSortType', this.sortType);
      localStorage.setItem('rolesSortReverse', this.sortReverse);
    },
    convertFilters() {
      const filters = `?page=${this.page ? this.page : 1}&id=${
        this.filters.id ? this.filters.id : ''
      }&name=${this.filters.name ? this.filters.name : ''}&desc=${
        this.filters.desc ? this.filters.desc : ''
      }&amount=${this.amount}&sortType=${this.sortType}&sortOrder=${
        this.sortReverse ? 'DESC' : 'ASC'
      }`;
      return filters;
    },
    sortCall(sortType) {
      this.sortReverse = this.sortType == sortType ? !this.sortReverse : false;
      this.sortType = sortType;
    },
    callData() {
      const timeWindow = 700;
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.data.current_page = null;
        this.setStorageFilters();
        this.getDatas();
      }, timeWindow);
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/role/search/${this.convertFilters()}`;
      axios(url).then((res) => {
        this.data = res.data;
        if (res.data.current_page > res.data.last_page) {
          this.page = 1;
        }
      });
    },
    openSaveRole(id) {
      this.$store.state.showRoleSave = id;
    },
    closeSaveRole() {
      this.$store.state.showRoleSave = null;
      this.callData();
    },
    confirmDel(id) {
      this.dialog = '';
      this.$bvModal
        .msgBoxConfirm('Tem certeza que deseja excluir esse perfil?', {
          size: 'md',
          contentClass: 'p-3',
          bodyClass: 'modal-body-fix',
          buttonSize: 'md',
          okVariant: 'danger',
          okTitle: 'Confirmar exclusão',
          cancelTitle: 'Cancelar',
          cancelVariant: 'metal',
          footerClass: 'p-4',
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value == true) {
            this.del(id);
          } else {
            this.$toasted.show(
              '<i class="fas fa-exclamation-triangle"></i> O Perfil não foi excluído!',
              {
                theme: 'toasted-primary',
                type: 'info',
                position: 'top-right',
                duration: 5000,
              }
            );
          }
        });
    },
    del(id) {
      const url = `${baseApiUrl}/v1/role/delete/${id}`;
      axios(url)
        .then((res) => {
          this.logMessage(res);
          this.getDatas();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
  },
  watch: {
    amount() {
      if (this.page == 1) {
        this.callData();
      } else {
        this.page = 1;
      }
    },
    page() {
      this.callData();
    },
    sortType() {
      this.callData();
    },
    sortReverse() {
      this.callData();
    },
  },
  mounted() {
    this.getDatas();
    window.scroll(0, 0);
  },
};
</script>
